import React from 'react';
import { Copy, ExternalLink } from 'lucide-react';
import { Button } from '@/app/_module/components/ui/button';
import { useToast } from '@/app/_module/hooks/use-toast';
import { cn } from '@/app/_module/lib/utils';
import { Panel, Section, focusRing } from './primitives';

export function LandingPageSection({ slug }: { slug: string }) {
  const { toast } = useToast();
  const host = `${slug}.insuracentral.com`;
  const url = `https://${host}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast({ title: 'Link copied', description: host });
    } catch {
      toast({ title: "Couldn't copy the link", description: 'Select the address and copy it instead.', variant: 'destructive' });
    }
  };

  return (
    <Section
      id="a2p-business-page"
      title="Business page"
      description="Your public page. Carrier reviewers visit it to confirm your business."
    >
      <Panel className="flex flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5">
        <p className="min-w-0 break-all text-sm font-medium text-neutral-900">{host}</p>
        <div className="flex gap-2.5">
          <Button variant="outline" size="sm" onClick={copy} className={cn('h-11 flex-1 sm:h-9 sm:flex-none', focusRing)}>
            <Copy />
            Copy link
          </Button>
          <Button asChild variant="outline" size="sm" className={cn('h-11 flex-1 sm:h-9 sm:flex-none', focusRing)}>
            <a href={url} target="_blank" rel="noopener noreferrer">
              <ExternalLink />
              Open page
            </a>
          </Button>
        </div>
      </Panel>
    </Section>
  );
}
